import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../../../../core/modules/shared.module';
import {AddModuleDialogComponent} from './add.module.dialog.component';

const routes = [{path: 'moduledialog', component: AddModuleDialogComponent}];

@NgModule({
  declarations: [AddModuleDialogComponent],
  imports: [SharedModule, RouterModule.forChild(routes)],
  exports: [AddModuleDialogComponent]
})

export class AddModuleDialogModule {}


// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/modules/add/add.module.dialog.module.ts